import React, { PureComponent } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import { getUserById, updateUser, resendEmail } from '../actions/users'
import { ButtonBackDiv, DivContentBox, DivTitleBox } from '../components/common/styled'
import Spinner3Bounce from '../components/spinner_3_bounce'
import EditUserComponent from '../components/users/edit_user'

class EditUser extends PureComponent {
  componentDidMount() {
    const {
      match: { params },
    } = this.props
    const { id } = params
    this.props.getUserById(id)
  }

  onCancelEdit = () => this.props.goToList()

  updateUser = async (user) => {
    const { props } = this
    this.setState({ errorDetails: [], errors: {} })
    await props.updateUser(user.id, user)
    this.props.goToList()
  }

  resendEmail = async (email) => {
    const { props } = this
    await props.resendEmail(email)
  }

  render() {
    const { props } = this
    const { errorMessage, isAuthenticated, isFetching, user } = props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    return (
      <div className='animated fadeIn'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-9 col-sm-9'>
              <ButtonBackDiv>
                <Button bsPrefix='btn btn-w-m btn-default' onClick={() => props.goToList()}>
                  <i className='fa fa-arrow-left' /> Back
                </Button>
              </ButtonBackDiv>
            </div>
            <div className='col-xs-3 col-sm-3 text-end'>
              <Button bsPrefix='btn btn-w-m btn-default' onClick={() => props.history.push('/users/add')}>
                <i className='fa fa-user-plus' /> Create User
              </Button>
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>{errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}</div>

          <EditUserComponent
            resendEmail={this.resendEmail}
            updateUser={this.updateUser}
            onCancel={this.onCancelEdit}
            user={user}
            history={props.history}
            errorMessage={errorMessage}
          />
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.getUserById.errorMessage,
  user: state.getUserById.user,
  isFetching: state.getUserById.isFetching,
  pageHash: ownProps.location.hash,
  navigateToIdentity: (id) => ownProps.history.push(`/users/${id}`),
  goToList: () => window.history.back(),
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      checkSession,
      getUserById,
      updateUser,
      resendEmail,
      navigateToPage: (p) => ownProps.history.push('#/page/' + p),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditUser))
